import React, { useEffect, useMemo, useState, useRef, useContext } from "react";
import Info from "../Info/info";
import InfoTitle from "../Info/InfoTitle";
import styles from "../Add Beneficiary/styles/new_beneficiary.module.css";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";

import "./styles/phone.css";
import { Switch } from "@mui/material";
import { Beneficiarytrustee } from "../Beneficiarytrustee/Beneficiarytrustee";
import PartnerFileShare from "../Partner Files/PartnerFileShare";
import PartnerSharingPerson, {
  EMPTY_PERSON_SHARING,
  personSharingValue,
} from "../Partner Sharing/PartnerSharingPerson";
import { getPartner } from "../Partner Sharing/PartnerSharing";
import { isPendingApproval } from "../../../Utils/partnerApproval";
import { canEditRecord } from "../../../Utils/partnerApproval";
import {
  canEditAnything,
  changedFields,
  editablePersonSections,
  mergeProposedIds,
  readProposals,
  viewablePersonSections,
} from "../../../Utils/partnerPropose";
import ProposedField from "../Partner Sharing/ProposedField";
import proposed from "../Partner Sharing/styles/ProposedField.module.css";
import ViewOnly from "../../ViewOnly";
import AssetType from "../Asset Type/AssetType";
import { UserData } from "../../../Context/DataContext";
import AddNewAsset from "./AddNewAsset";
import AddBeneficiary from "../Add Asset/AddBeneficiary";
import { RandomId } from "../../../Utils/RandomId";
import Confirmation from "../../Confirmation/Confirmation";
import config from "../../../config";
import { handleIssues } from "../../../Utils/handleIssues";
import { sendEmail } from "../../../Utils/beneficiary";
import { floatMessage } from "../../../Utils/floatMessage";
import { useAuth } from "../../../Context/AuthContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import CropperImage from "antd-cropper-img";
import { DeleteOutlined } from "@ant-design/icons";
import uploadButton from "../Add Beneficiary/styles/img/upload_button.png";
import editButton from "../Add Beneficiary/styles/img/edit_button.svg";
import { Upload as UploadProfilePicture } from "antd";
import useWindowDimensions from "../../Footer/footer";
import { encryptFileAES } from "../../../Utils/OstreonEncryption";

const base_url = config.base_url;
function EditTrustee({
  toEdit,
  onClose,
  /*
    Whether to offer the partner-sharing section.

    False when this modal is opened from the promotion card, which reaches
    the SAME advisor record but is not a page about managing that advisor
    -- it is the sponsor's own card. Offering "share this trusted advisor
    with {partner}" there asks the customer to share the partner with the
    partner, which is not a question. Opened from the Trusted Advisors
    page it is the right question, and the section stays.
  */
  showPartnerSharing = true,
  /*
    Whether to offer the file-sharing panel.

    True only from the promotion card, which is where the customer meets
    their partner. On the Trusted Advisors page this same modal is about
    an advisor of the customer's own choosing, who is not the partner and
    has no business with a drop box aimed at them.
  */
  showPartnerFiles = false,
}) {
  const { width } = useWindowDimensions();
  const editable = toEdit?.editable === false ? false : true;
  const [previewImage, setPreviewImage] = useState(
    toEdit.profile_avatar ? toEdit.profile_avatar : null
  );
  const [initialImage, setInitialImage] = useState(
    toEdit.profile_avatar ? toEdit.profile_avatar : null
  );

  const [extension, setExtension] = useState(
    toEdit.profile_avatar
      ? () => {
          let extension = toEdit.profile_avatar[0];

          if (extension === "/") extension = ".jpg";
          else if (extension === "i") extension = ".png";
          return extension;
        }
      : null
  );

  const [image, setImage] = useState(null);
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const divElementRef = useRef(null);

  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddTrustee.NewTrustee
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddTrustee.NewTrustee);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    const divElement = divElementRef.current;

    const handleScroll = () => {
      const scrollTop = divElement.scrollTop;
      const scrollHeight = divElement.scrollHeight;
      const clientHeight = divElement.clientHeight;
      setShowTopShadow(scrollTop > 0);
      setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 10);
    };

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const userData = UserData();
  const auth = useAuth();
  const [showConfirmation, setShowConfirmation] = useState(false);

  /*
    Which assets and beneficiaries this advisor is attached to, as the
    CUSTOMER holds it -- the whole of it, not the partner's view.

    Neither list is stored on the advisor: the relation lives at the other
    end, on each asset's and each beneficiary's own `trustees`. Derived once
    here because three things need the same answer: the form's starting
    value, what "Previous" restores, and the baseline a partner's partial
    list is merged against.
  */
  const trusteeRelations = useMemo(
    () => ({
      assets: userData.UserData.assets
        .filter((asset) => asset.trustees.includes(toEdit.user_id))
        .map((e) => e.asset_id),
      beneficiaries: userData.UserData.beneficiaries
        .filter((beneficiary) => beneficiary.trustees.includes(toEdit.user_id))
        .map((e) => e.user_id),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userData.UserData.assets, userData.UserData.beneficiaries, toEdit.user_id]
  );

  const [trustee, setTrustee] = useState({
    user_id: toEdit.user_id,
    name: toEdit.name,
    additional_information: toEdit.additional_information,
    email: toEdit.email,
    phone_number: toEdit.phone_number,
    awareness_status: toEdit.awareness_status,
    profile_avatar: toEdit.profile_avatar,
    // See trusteeRelations above: the same two lists, derived once.
    assets: trusteeRelations.assets,
    beneficiaries: trusteeRelations.beneficiaries,
    deleted_assets: [],
    deleted_beneficiaries: [],
    /*
      Seeded from the advisor being edited. One saved before these existed has
      neither, and both default off.
    */
    /*
      Every sharing flag this record carries, read from one place.

      Listed by hand this went wrong twice over: a row added later was
      missed here and missed again in the save, so switches the customer
      set came back off. personSharingValue projects the key set from
      EMPTY_PERSON_SHARING, with `=== true` throughout -- a record saved
      before a flag existed has granted nothing, and `undefined` is not a
      permission.
    */
    ...personSharingValue(toEdit),
    /*
      The partner's outstanding suggestions, carried for the same reason: a
      save that left them out would discard every one the customer had not
      answered.
    */
    partner_changes: Array.isArray(toEdit?.partner_changes)
      ? toEdit.partner_changes
      : [],
  });
  /*
    Null when this user has no partner, which is what hides the section.
  */
  const partner = getPartner(userData);

  /*
    Opened to review an advisor the partner created. Every field is editable, as
    the interstitial promises; only the confirming button changes, because
    saving IS approving here.
  */
  const awaitingApproval = isPendingApproval(toEdit);
  /*
    Read-only: a partner looking at something the customer wrote.

    They may read what was shared and nothing else. Save and Delete are not
    rendered, and every control that assigns or uploads is withheld, so the
    only things left are reading and closing. Editing is possible for exactly
    one case -- their own draft the customer has not approved -- which is what
    canEditRecord decides.

    The writers in this view are stubbed too, so nothing could persist even if
    a control were missed; this is what makes that visible rather than a
    surprise.
  */
  const readOnly = !canEditRecord(userData, toEdit);

  /*
    ---- partner edits, both directions ----

    The same two permissions a beneficiary has: who this advisor is, and how
    to reach them. A granted section stays live inside the read-only modal,
    Save becomes "propose", and the customer answers at the top of their own
    copy.
  */
  const personSections = editablePersonSections(toEdit);
  /*
    Which sections this partner may SEE, as against change.

    The "add" controls below hang off this rather than off readOnly. A
    partner granted the assets row should see the + that says a list can be
    added to -- otherwise the row reads as though it has nothing to do with
    them -- but only an EDIT makes it do anything, and that is ViewOnly's
    job: the region is marked editable only when the edit was granted, so
    without it the control renders and takes no clicks.
  */
  const personViews = viewablePersonSections(toEdit);
  const canSeeAssets = !readOnly || personViews.assets;
  const canSeeBeneficiaries = !readOnly || personViews.beneficiaries;
  const canPropose =
    readOnly &&
    Boolean(userData.partnerPropose) &&
    canEditAnything("trustee", toEdit);
  const editableIf = (on) =>
    canPropose && on ? { "data-viewonly-editable": "" } : {};

  const [proposals, setProposals] = useState({});
  const [decisions, setDecisions] = useState({});
  useEffect(() => {
    let live = true;
    (async () => {
      const read = await readProposals(toEdit, userData.private_key);
      if (live) setProposals(read);
    })();
    return () => {
      live = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toEdit?.user_id]);

  /*
    One switch, directly above the field it is about, and the field outlined
    to match. Nothing for a field nobody has proposed a change to, and
    nothing at all on the partner's own screen -- they are the ones asking.
  */
  const review = (field, label, children = null) => (
    <ProposedField
      field={field}
      label={label}
      proposals={resolvedProposals}
      decisions={decisions}
      onDecide={decideProposal}
      active={!readOnly}
      disabled={userData.isFreezed}
    >
      {children}
    </ProposedField>
  );
  // The purple outline, for a box (`field`) or for a whole region (`block`).
  const reviewMark = (field, kind = "field") =>
    !readOnly && resolvedProposals[field] ? proposed[kind] : "";

  /*
    Every suggestion arrives accepted.

    The alternative is a modal that opens showing the customer's own values
    with switches offering something they have to flip one at a time to even
    see. Starting from the partner's version means the record reads as it
    WOULD read if they saved, and refusing one is a single flip back -- which
    is also what makes saving an answer to all of them rather than only to
    the ones that were touched.

    Once per record, and never on the partner's own screen: they are the ones
    asking, and pre-filling their form with their own pending proposal would
    have them re-propose it.
  */
  const defaultsApplied = useRef(false);
  useEffect(() => {
    if (defaultsApplied.current || readOnly) return;
    const fields = Object.keys(proposals);
    if (!fields.length) return;
    defaultsApplied.current = true;
    setDecisions(Object.fromEntries(fields.map((field) => [field, true])));
    setTrustee((prev) => {
      const next = { ...prev };
      for (const field of fields) next[field] = resolvedProposals[field]?.value;
      return next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proposals, readOnly]);

  /*
    A partner's proposal as it would actually land, which for the two
    relation rows is not what they sent.

    `assets` and `beneficiaries` are lists of ids, and the lists the partner
    was shown had the withheld ones taken out -- the server intersects both
    with what they may already see. So their edit covers the visible half
    and says nothing about the rest, and the rest has to survive it.
    Resolved here rather than at the point of acceptance so the switch is
    about what saving would really keep.
  */
  const partnerCouldSee = (collection) => (id) =>
    (userData.UserData?.[collection] || []).find((r) =>
      collection === "assets" ? r.asset_id === id : r.user_id === id
    )?.share_with_partner === true;

  const resolvedProposals = useMemo(() => {
    const out = {};
    for (const [field, change] of Object.entries(proposals)) {
      out[field] =
        field === "assets" || field === "beneficiaries"
          ? {
              ...change,
              value: mergeProposedIds(
                trusteeRelations[field],
                change?.value,
                partnerCouldSee(field)
              ),
            }
          : change;
    }
    return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proposals, toEdit]);

  const decideProposal = (field, takeNew) => {
    setDecisions((prev) => ({ ...prev, [field]: takeNew }));
    const value = takeNew
      ? resolvedProposals[field]?.value
      : field === "assets" || field === "beneficiaries"
      ? trusteeRelations[field]
      : toEdit?.[field];
    setTrustee((prev) => ({ ...prev, [field]: value }));
  };
  const approvalContent =
    websiteCurrentLang?.content?.User?.PartnerApproval?.PartnerApproval;
  const [error, setError] = useState({
    name: "",
    email: "",
    phone_number: "",
    additional_information: "",
  });

  const [duplicatedName, setDuplicatedName] = useState(false);
  const duplicateError = content.newTrusteeError1;
  // textarea
  const maxMessageLength = 10000; // Define the maximum character length for the message field

  const textareaRef = useRef(null);
  function encodeFileToBase64(file) {
    if (!file) return;
    const base64String = new Promise((resolve, reject) => {
      const reader = new FileReader();

      // Callback function to handle the file reading operation
      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // Extract base64 string (remove data URL prefix)
        resolve(base64String); // Resolve with the base64 string
      };

      // Callback function to handle errors during file reading
      reader.onerror = (error) => {
        reject(error); // Reject with the error object
      };

      // Read the file as a data URL
      reader.readAsDataURL(file);
    });
    let extension = base64String[0];

    if (extension === "/") extension = ".jpg";
    else if (extension === "i") extension = ".png";
    setPreviewImage(base64String);
    setExtension(extension);
    return base64String;
  }
  const deleteImageHandler = async () => {
    // setLoading(true);
    /*
      And never from a partner's screen. A partner has no picture controls
      for an advisor at all -- there is no row for one and the column is
      not rendered -- and this would post against their OWN folder, since
      the endpoint keys on the session user. `editable` used to stop it by
      accident, back when a partner's copy arrived inert.
    */
    if (!editable || userData.partnerReadOnly) return;
    await fetch(base_url + "user/profile/pic/delete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `profile_id=${toEdit.user_id}`,
      credentials: "include",
    })
      .then((res) => res.json())
      .then(async (res) => {
        setPreviewImage(null);
        setExtension(null);
        setImage(null);
        setInitialImage(null);
      });
  };

  const handleChangeDescription = () => {
    const textarea = textareaRef.current;
    // Reset the textarea height to 0 to correctly calculate the scrollHeight
    textarea.style.height = "0";
    const height = textarea.scrollHeight;
    textarea.style.height = `${height}px`;
  };
  // textarea
  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const cleanErrors = () => {
    setTimeout(() => {
      setError({
        name: "",
        email: "",
        phone_number: "",
        additional_information: "",
      });
    }, 5000);
  };
  const isTrusteeEmpty = () => {
    let isEmpty = false;
    let error_ = {
      name: "",
      email: "",
      phone_number: "",
      additional_information: "",
    };
    /*
      A partner is checked only on what they were given.

      Their copy of this advisor holds the shared part and nothing else, so an
      email and phone number the customer withheld are both "" -- and the
      check below reads that as "this advisor has no way of being reached"
      and refuses the save. The partner sees a button that does nothing, over
      fields that are not on their screen.

      Additional information has no flag at all, so theirs is always empty.
    */
    const checks = {
      identity: !canPropose || personSections.identity,
      /*
        An advisor's contact details are view-only now, exactly as a
        beneficiary's are -- there is no edit flag for them at all -- so
        this is always false for a partner, and their copy of a withheld
        address is "" either way.
      */
      contact: !canPropose || personSections.contact,
      // Their message, behind its own row.
      message: !canPropose || personSections.message,
    };
    if (
      checks.message &&
      trustee.additional_information.length > maxMessageLength
    ) {
      isEmpty = true;
      error_ = { ...error_, additional_information: content.newTrusteeError2 };
    }
    if (checks.identity && trustee.name === "") {
      isEmpty = true;
      error_ = { ...error_, name: content.newTrusteeError3 };
    }

    // check if trusted advisor with this name is exist
    if (checks.identity && trustee.name !== "") {
      const editedTrusteeName = trustee.name;
      const editedTrusteeId = trustee.user_id;
      let hasMatchingAsset = userData.UserData.trustees.some(
        (trustItem) =>
          trustItem.name.toLowerCase() === editedTrusteeName.toLowerCase() &&
          trustItem.user_id !== editedTrusteeId &&
          trustItem.editable &&
          editable
      );

      if (hasMatchingAsset) {
        isEmpty = true;
        setDuplicatedName(true);
        document.getElementById("scrollContainer").scrollTop = 0;
      }
    }

    if (checks.contact && trustee.email === "" && trustee.phone_number === "") {
      isEmpty = true;
      error_ = { ...error_, contacts: content.newTrusteeError4 };
    }

    if (
      checks.contact &&
      trustee.phone_number !== "" &&
      trustee.phone_number.length < 5
    ) {
      isEmpty = true;
      error_ = { ...error_, phone_number: content.newTrusteeError5 };
    }

    if (checks.contact && trustee.email !== "" && !isValidEmail(trustee.email)) {
      isEmpty = true;
      error_ = { ...error_, email: dublicatedcontent.dublicatedText47 };
    }

    setError(error_);
    cleanErrors();

    return isEmpty;
  };
  const handleDeletedAssets = () => {
    var new_assets = userData.UserData.assets.map((asset) => {
      if (trustee.deleted_assets.includes(asset.asset_id)) {
        return {
          ...asset,
          trustees: asset.trustees.filter((e) => e !== trustee.user_id),
        };
      } else {
        return asset;
      }
    });
    return new_assets;
  };
  const handleDeletedBeneficiaries = () => {
    var new_beneficiaries = userData.UserData.beneficiaries.map(
      (beneficiary) => {
        if (trustee.deleted_beneficiaries.includes(beneficiary.user_id)) {
          return {
            ...beneficiary,
            trustees: beneficiary.trustees.filter((e) => e !== trustee.user_id),
          };
        } else {
          return beneficiary;
        }
      }
    );
    return new_beneficiaries;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (isTrusteeEmpty()) return;

    /*
      A partner's save is a proposal and stops here -- the customer's advisor,
      and every asset and beneficiary attached to them, are untouched until
      the customer accepts it.
    */
    if (canPropose) {
      const fields = changedFields("trustee", toEdit, trustee);
      if (!fields.length) {
        onClose();
        return;
      }
      await userData.partnerPropose("trustee", toEdit.user_id, fields, trustee);
      onClose();
      return;
    }

    var new_assets = handleDeletedAssets();
    var new_beneficiaries = handleDeletedBeneficiaries();
    new_assets = new_assets.map((asset) => {
      if (trustee.assets.includes(asset.asset_id)) {
        return {
          ...asset,
          trustees: [...new Set([...asset.trustees, trustee.user_id])],
        };
      } else {
        return asset;
      }
    });
    new_beneficiaries = new_beneficiaries.map((beneficiary) => {
      if (trustee.beneficiaries.includes(beneficiary.user_id)) {
        return {
          ...beneficiary,
          trustees: [...new Set([...beneficiary.trustees, trustee.user_id])],
        };
      } else {
        return beneficiary;
      }
    });
    var new_trustees = userData.UserData.trustees.map((e) => {
      if (e.user_id === trustee.user_id) {
        return {
          editable,
          user_id: trustee.user_id,
          name: trustee.name,
          additional_information: trustee.additional_information,
          email: trustee.email,
          phone_number: trustee.phone_number,
          awareness_status: trustee.awareness_status,
          new: image ? true : false,
          profile_avatar: previewImage,
          originalImage: image,
          /*
            Every sharing flag, taken from one place.

            This rebuilds the advisor field by field, so anything not listed
            is dropped -- and listing them by hand is what went wrong: two
            were named and the rest were not, so the whole Edit column and
            three of the five View switches reset themselves to off on every
            save. The customer set them, saved, reopened, and found them
            back where they started.

            personSharingValue reads the key set from EMPTY_PERSON_SHARING,
            so a row added later is carried here without this line changing.
          */
          ...personSharingValue(trustee),
          /*
            Saving a partner-created advisor is the approval, and the only thing
            that clears the flag. created_by_partner is kept: who created it
            stays true after it is accepted.
          */
          pending_approval: false,
          created_by_partner: e?.created_by_partner || "",
          /*
            And the partner's suggestions, settled -- all of them.

            Saving IS the answer. Every suggestion arrives with its switch
            on, so a value the customer left alone is one they kept and a
            switch they turned off is one they refused; either way the
            question has been put, and none of them comes back. Leaving the
            untouched ones queued would ask again about changes already in
            the record.
          */
          partner_changes: [],
        };
      } else {
        return e;
      }
    });
    //We would need to find the legal entity whose associated_trustee has same value as toEdit?.user_id
    let new_legal =
      userData?.UserData?.legal?.filter(
        (e) => e?.associated_trustee !== toEdit?.user_id
      ) || [];
    let associated_legal = userData?.UserData?.legal?.filter(
      (e) => e?.associated_trustee === toEdit?.user_id
    )[0];
    if (associated_legal) {
      new_legal = [
        ...new_legal,
        {
          ...associated_legal,
          name: trustee?.name,
          email: trustee?.email,
          phone_number: trustee?.phone_number,
          additional_information: trustee?.additional_information,
          notify: trustee?.awareness_status,
        },
      ];
    }
    var new_issues = handleIssues({
      ...userData.UserData,
      assets: new_assets,
      beneficiaries: new_beneficiaries,
      trustees: new_trustees,
    });
    userData.setUserData({
      ...userData.UserData,
      assets: new_assets,
      beneficiaries: new_beneficiaries,
      trustees: new_trustees,
      issues: new_issues,
      legal: new_legal,
    });
    // if (!new_assets.length===0)
    // {
    //     userData.setUserData({...userData.UserData, "assets":new_assets, "trustees":new_trustees})
    // }
    if (image) {
      // See deleteImageHandler: never from a partner's screen.
      if (!editable || userData.partnerReadOnly) return;
      const formData = new FormData();
      formData.append("profile_id", trustee.user_id);
      const encrypted_image = await encryptFileAES(userData.private_key, image);
      formData.append("file", encrypted_image);
      fetch(base_url + "user/profile/pic/upload", {
        method: "POST",
        mode: "cors",
        body: formData,
        credentials: "include",
      }).finally(() => {
        return;
      });
    }
    if (
      trustee.awareness_status === "true" &&
      toEdit.awareness_status === "false"
    ) {
      sendEmail(trustee, "trustee", [trustee?.email]);
      auth.setAwarenessEmail(auth.awareness_email + 1);
    }
    if (!image && !initialImage) {
      deleteImageHandler();
    }
    userData.Update(RandomId(10));
    onClose();
    floatMessage(dublicatedcontent?.saved);
    //Update assets

    return;
  };
  /*
    Run through a catch rather than fired and forgotten.

    These savers are async, so anything they throw becomes a rejected promise
    nobody is holding: the button does nothing, there is no message, and
    nothing on screen says which line gave up. That is how a JSON.parse of an
    empty string hid through a whole round of testing. Logging it does not
    fix a failure, but it stops one being silent.
  */
  const runSave = (e) => {
    handleSave(e).catch((error) => console.log(error));
  };
  const editTrustee = (key, value) => {
    setTrustee({ ...trustee, [key]: value });
  };
  const trimNameField = (value) => {
    const name = value.trim();
    editTrustee("name", name);
  };
  useEffect(() => {
    console.log(trustee);
  }, [trustee]);
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);
  const deleteTrustee = () => {
    setShowConfirmation(false);
    onClose();
    floatMessage(dublicatedcontent?.deleted);
    var new_assets = userData.UserData.assets.map((asset) => {
      let new_trustees = asset.trustees.filter(
        (id_) => id_ !== trustee.user_id
      );
      return { ...asset, trustees: new_trustees };
    });
    var new_beneficiaries = userData.UserData.beneficiaries.map(
      (beneficiary) => {
        let new_trustees = beneficiary.trustees.filter(
          (id_) => id_ !== trustee.user_id
        );
        return { ...beneficiary, trustees: new_trustees };
      }
    );
    var new_issues = handleIssues(
      {
        ...userData.UserData,
        trustees: userData.UserData.trustees.filter(
          (trustee_) => trustee_.user_id !== trustee.user_id
        ),
        assets: new_assets,
        beneficiaries: new_beneficiaries,
      },
      userData.BillingData
    );
    userData.setUserData({
      ...userData.UserData,
      trustees: userData.UserData.trustees.filter(
        (trustee_) => trustee_.user_id !== trustee.user_id
      ),
      legal:
        userData.UserData.legal.filter(
          (e) => e?.associated_trustee !== trustee?.user_id
        ) || [],
      assets: new_assets,
      beneficiaries: new_beneficiaries,
      issues: new_issues,
    });
    userData.Update(RandomId(10));
  };

  const clearNameError = () => {
    setDuplicatedName(false);
  };

  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={
          width <= 599
            ? {
                height: window.innerHeight - 10,
              }
            : {}
        }
        className={styles.main_box}
      >
        <div onClick={onClose} className={styles.close_logo}></div>
        {/* Read-only for a partner: see canEditRecord. */}
        <ViewOnly active={readOnly}>
        <div className={styles.title}>
          {content.newTrusteeText23} {trustee.name}
        </div>
        <div
          /* Scrolls even when the contents are inert. */
          data-viewonly-scroll
          className={`${styles.popup_scrollable} ${styles.popup_scrollable_edit}`}
          id="scrollContainer"
          ref={divElementRef}
        >
          <div
            className={`${styles.shadow_top} ${
              showTopShadow ? styles.active : ""
            }`}
          />

          <div className={styles.main_data} {...editableIf(personSections.identity)}>
            <div
              className={styles.main_data_upper}
              style={{
                alignItems: "center",
              }}
            >
              <div className={styles.upper_left}>
                {review(
                  "name",
                  content?.newTrusteeText1,
                  <div
                    className={`${styles.input_title} ${styles.required_field}`}
                  >
                    {content.newTrusteeText1}
                  </div>
                )}
                <input
                  disabled={userData.isFreezed}
                  onClick={(e) => clearNameError()}
                  onBlur={(e) => trimNameField(e.target.value)}
                  value={trustee.name}
                  onChange={(e) => {
                    if (!editable) return;
                    editTrustee("name", e.target.value);
                  }}
                  className={`${styles.beneficiary_input} ${
                    error.name ? styles.field_error : ""
                  } ${duplicatedName ? styles.field_error : ""} ${reviewMark(
                    "name"
                  )}`}
                  placeholder={content.newTrusteeText1}
                ></input>
                {duplicatedName ? (
                  <div className={styles.error_message}>{duplicateError}</div>
                ) : null}
                {error.name ? (
                  <div className={styles.error_message}>{error.name}</div>
                ) : null}
              </div>
              {/*
                The picture column, and a partner never sees it.

                An advisor's photo has no sharing row, no flag and no entry
                in the whitelist -- the server sends none and the panel
                offers none -- so for a partner this would be an empty frame
                with an upload control behind it, inviting a change that
                could never be proposed. Hidden outright, as credentials are
                on an asset.
              */}
              {width > 590 && !userData.partnerReadOnly && (
                <div
                  disabled={!editable}
                  className={`${styles.upper_right} enable-disable-opacity`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transform: "translateY(33px)",
                  }}
                >
                  <div
                    className={`${styles.uploadPictureContainer} ${styles.black_logo_image}`}
                    style={{
                      width: "175px",
                      height: "175px",
                    }}
                  >
                    <div className={styles.upload_button_container}>
                      <div className={styles.upload_button}>
                        {initialImage && (
                          <>
                            <div
                              className={styles.previewImageContainer}
                              style={{
                                left: "0px",
                                zIndex: "5",
                                top: "17px",
                                width: "102px",
                                height: "102px",
                              }}
                            >
                              <img
                                src={`data:image/${extension};base64,${previewImage}`}
                                alt="benef. "
                                style={{
                                  zIndex: "5",
                                }}
                                className={styles.previewImage}
                              />
                              <div className={styles.displayDeleteIcon}>
                                <div
                                  className={styles.deletBackdrop}
                                  style={{
                                    width: "102px",
                                    height: "102px",
                                    left: "0px",
                                    top: "0px",
                                    zIndex: "5",
                                  }}
                                />
                                <div
                                  className={styles.deleteIcon}
                                  onClick={(e) => {
                                    if (!editable) return;
                                    setPreviewImage(null);
                                    setExtension(null);
                                    setImage(null);
                                    setInitialImage(null);
                                    // deleteImageHandler();
                                  }}
                                  style={{
                                    zIndex: "5",
                                  }}
                                >
                                  <DeleteOutlined />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <div
                          className={styles.upload_button}
                          style={{
                            left: "-45px",
                            top: "15px",
                          }}
                        >
                          {!previewImage && (
                            <img
                              src={uploadButton}
                              alt="upload button"
                              style={{
                                width: "110px",
                                height: "110px",
                              }}
                            />
                          )}

                          <CropperImage
                            dragMode="move"
                            rotatable={true}
                            zoomSlider={false}
                            zoomOnTouch={false}
                            wheelZoomRatio={0.2}
                            zoomOnWheel={true}
                            modalTitle={dublicatedcontent?.edit_image}
                            quality={0.4}
                            classNames={"xxx"}
                            scalable={true}
                            cropShape="round"
                            restore={true}
                          >
                            <UploadProfilePicture
                              disabled={!editable}
                              multiple={false}
                              maxCount={1}
                              accept=".jpg, .jpeg, .png"
                              beforeUpload={async (file) => {
                                // const reader = new FileReader();
                                // reader.readAsDataURL(file);
                                setImage(file);
                                // reader.onload = (e) => {
                                //   setPreviewImage(reader.result);
                                // };
                                setInitialImage(null);
                                setPreviewImage(await encodeFileToBase64(file));
                                // Prevent upload
                                return false;
                              }}
                              itemRender={(
                                originNode,
                                file,
                                fileList,
                                { remove }
                              ) => {
                                return (
                                  <div
                                    className={styles.previewImageContainer}
                                    style={{
                                      left: "4px",
                                      top: "0px",
                                      width: "102px",
                                      height: "102px",
                                    }}
                                  >
                                    {previewImage && (
                                      <>
                                        <img
                                          src={`data:image/${extension};base64,${previewImage}`}
                                          alt="benef. "
                                          className={styles.previewImage}
                                        />

                                        <div
                                          className={styles.displayDeleteIcon}
                                        >
                                          <div
                                            className={styles.deletBackdrop}
                                          />
                                          <div
                                            className={styles.deleteIcon}
                                            onClick={(e) => {
                                              if (!editable) return;
                                              remove(file);
                                              setImage(null);
                                              setPreviewImage(null);
                                            }}
                                          >
                                            <DeleteOutlined />
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                );
                              }}
                            >
                              <div
                                className={styles.upload_trigger}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "110px",
                                  height: "110px",
                                  left: "5px",
                                }}
                              >
                                {!previewImage && (
                                  <p
                                    className={styles.uploadText}
                                    style={
                                      localStorage.getItem("language") === "fr"
                                        ? {
                                            fontSize: "14px",
                                            marginRight: "5px",
                                            width: "100px",
                                          }
                                        : {
                                            fontSize: "12px",
                                            marginLeft: "5px",
                                            paddingRight: "10px",
                                          }
                                    }
                                  >
                                    {content.newTrusteeText24}
                                  </p>
                                )}

                                {previewImage && (
                                  <img
                                    className={styles.editButton}
                                    style={{
                                      bottom: "10px",
                                      right: "12px",
                                      zIndex: "5",
                                    }}
                                    src={editButton}
                                    alt="edit"
                                  />
                                )}
                              </div>
                            </UploadProfilePicture>
                          </CropperImage>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.delay_period}>
            <div className={`${styles.bold_title} ${styles.required_field}`}>
              {content.newTrusteeText2}
            </div>
            <Info message={content.newTrusteeText3} />
          </div>
          <div className={styles.error_message}>
            {error.contacts ? error.contacts : null}
          </div>
          <div
            className={`${styles.main_data_upper} ${
              error.contacts ? styles.err_container : ""
            }`}
            {...editableIf(personSections.contact)}
          >
            <div className={styles.upper_left}>
              {review(
                "email",
                content?.newTrusteeText4,
                <div className={`${styles.input_title}`}>
                  {content.newTrusteeText4}
                </div>
              )}
              <input
                disabled={userData.isFreezed}
                value={trustee.email}
                style={{ border: error.email ? "0.5px solid red" : null }}
                onChange={(e) => {
                  if (!editable) return;
                  editTrustee("email", e.target.value);
                }}
                className={`${styles.beneficiary_input_email} ${reviewMark(
                  "email"
                )}`}
                placeholder={content.newTrusteeText4}
              ></input>
              <div className={styles.error_message}>
                {error.email ? error.email : null}
              </div>
              <div className={styles.choice}>
                <InfoTitle
                  message={content.newTrusteeText5}
                  title={content.newTrusteeText6}
                  type={"small"}
                />
                <div
                  disabled={userData.isFreezed || auth.awareness_email >= 12}
                  className={`${styles.choice_container} ${
                    isValidEmail(trustee.email) ? "" : styles.disabled_choice
                  }`}
                >
                  <span className={styles.switch_option}>
                    {dublicatedcontent?.dublicatedText102}
                  </span>
                  <div className={styles.switch_toggle}>
                    <Switch
                      disabled={!editable}
                      checked={trustee.awareness_status === "true"}
                      onClick={() =>
                        setTrustee({
                          ...trustee,
                          awareness_status:
                            trustee.awareness_status === "true"
                              ? "false"
                              : "true",
                        })
                      }
                    />
                  </div>
                  <span
                    className={styles.switch_option}
                    style={{ marginRight: "10px" }}
                  >
                    {dublicatedcontent?.dublicatedText101}
                  </span>
                </div>
              </div>
              {auth.awareness_email >= 12 && (
                <div className={styles.error_message}>
                  {content.newTrusteeText7}
                </div>
              )}
            </div>
            <div className={styles.upper_right}>
              {review(
                "phone_number",
                content?.newTrusteeText8,
                <div className={styles.input_title}>
                  {content.newTrusteeText8}
                </div>
              )}
              <div
                disabled={userData.isFreezed}
                className={`${styles.phone_div} ${reviewMark(
                  "phone_number",
                  "block"
                )}`}
                style={{
                  border: error.phone_number ? "0.5px solid red" : null,
                }}
              >
                <PhoneInput
                  className={"enable-disable-opacity"}
                  disabled={userData.isFreezed || !editable}
                  value={trustee.phone_number}
                  localization={
                    websiteCurrentLang?.label === "fr"
                      ? fr_phone_countries
                      : undefined
                  }
                  country={websiteCurrentLang?.label === "fr" ? "fr" : "us"}
                  placeholder={content.newTrusteeText9}
                  onChange={(e) => {
                    if (!editable) return;
                    editTrustee("phone_number", e);
                  }}
                />
              </div>
              <div className={styles.error_message}>
                {error.phone_number ? error.phone_number : null}
              </div>
              <InfoTitle
                movetoleft={true}
                message={content.newTrusteeText10}
                title={content.newTrusteeText11}
                type={"small"}
              />
            </div>
            {/* The narrow layout's picture column; see the wide one above. */}
            {width <= 590 && !userData.partnerReadOnly && (
              <div
                disabled={!editable}
                className={`${styles.upper_right} enable-disable-opacity`}
                style={{
                  display: "flex",
                  alignItems: "center",

                  justifyContent: "center",
                }}
              >
                <div
                  className={`${styles.uploadPictureContainer} ${styles.black_logo_image}`}
                  style={{
                    width: "200px",
                    height: "200px",
                  }}
                >
                  <div className={styles.upload_button_container}>
                    <div className={styles.upload_button}>
                      {initialImage && (
                        <>
                          <div
                            className={styles.previewImageContainer}
                            style={{
                              left: "25px",
                              zIndex: "5",
                              top: "20px",
                              width: "110px",
                              height: "110px",
                            }}
                          >
                            <img
                              src={`data:image/${extension};base64,${previewImage}`}
                              alt="benef. "
                              style={{
                                zIndex: "5",
                              }}
                              className={styles.previewImage}
                            />
                            <div className={styles.displayDeleteIcon}>
                              <div
                                className={styles.deletBackdrop}
                                style={{
                                  width: "110px",
                                  height: "110px",
                                  left: "1px",
                                  top: "0px",
                                  zIndex: "5",
                                }}
                              />
                              <div
                                className={styles.deleteIcon}
                                onClick={(e) => {
                                  setPreviewImage(null);
                                  setExtension(null);
                                  setImage(null);
                                  setInitialImage(null);
                                  // deleteImageHandler();
                                }}
                                style={{
                                  zIndex: "5",
                                }}
                              >
                                <DeleteOutlined />
                              </div>
                            </div>{" "}
                          </div>
                        </>
                      )}
                      <div className={styles.upload_button}>
                        {previewImage || initialImage ? (
                          <></>
                        ) : (
                          <img
                            src={uploadButton}
                            alt="upload button"
                            style={{
                              width: "120px",
                              height: "120px",
                            }}
                          />
                        )}

                        <CropperImage
                          dragMode="move"
                          rotatable={true}
                          zoomSlider={false}
                          zoomOnTouch={false}
                          wheelZoomRatio={0.2}
                          zoomOnWheel={true}
                          modalTitle={dublicatedcontent?.edit_image}
                          quality={0.4}
                          classNames={"xxx"}
                          scalable={true}
                          cropShape="round"
                          restore={true}
                        >
                          <UploadProfilePicture
                            multiple={false}
                            maxCount={1}
                            accept=".jpg, .jpeg, .png"
                            beforeUpload={async (file) => {
                              // const reader = new FileReader();
                              // reader.readAsDataURL(file);
                              setImage(file);
                              // reader.onload = (e) => {
                              //   setPreviewImage(reader.result);
                              // };
                              setInitialImage(null);
                              setPreviewImage(await encodeFileToBase64(file));
                              // Prevent upload
                              return false;
                            }}
                            itemRender={(
                              originNode,
                              file,
                              fileList,
                              { remove }
                            ) => {
                              return (
                                <div
                                  className={styles.previewImageContainer}
                                  style={{
                                    top: "5px",
                                    left: "8px",
                                    width: "110px",
                                    height: "110px",
                                  }}
                                >
                                  {previewImage && (
                                    <>
                                      <img
                                        src={`data:image/${extension};base64,${previewImage}`}
                                        alt="benef. "
                                        className={styles.previewImage}
                                      />

                                      <div className={styles.displayDeleteIcon}>
                                        <div className={styles.deletBackdrop} />
                                        <div
                                          className={styles.deleteIcon}
                                          onClick={(e) => {
                                            remove(file);
                                            setImage(null);
                                            setPreviewImage(null);
                                          }}
                                        >
                                          <DeleteOutlined />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              );
                            }}
                          >
                            <div
                              className={styles.upload_trigger}
                              style={{
                                width: "120px",
                                height: "120px",
                              }}
                            >
                              {!previewImage && (
                                <p
                                  className={styles.uploadText}
                                  style={
                                    localStorage.getItem("language") === "fr"
                                      ? {
                                          fontSize: "13px",
                                          marginLeft: "5px",
                                          width: "100px",
                                        }
                                      : {
                                          fontSize: "13px",
                                          marginLeft: "5px",
                                        }
                                  }
                                >
                                  {content.newTrusteeText24}
                                </p>
                              )}

                              {previewImage && (
                                <img
                                  className={styles.editButton}
                                  style={{
                                    bottom: "7px",
                                    zIndex: "5",
                                    right: "15px",
                                  }}
                                  src={editButton}
                                  alt="edit"
                                />
                              )}
                            </div>
                          </UploadProfilePicture>
                        </CropperImage>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className={styles.main_data_lower}
            {...editableIf(personSections.message)}
          >
            {review(
              "additional_information",
              content?.newTrusteeText12,
              <div className={styles.delay_period}>
                <div className={styles.input_title}>
                  {content.newTrusteeText12}
                </div>
              </div>
            )}
            <textarea
              disabled={userData.isFreezed}
              maxlength={maxMessageLength}
              value={trustee.additional_information}
              ref={textareaRef}
              placeholder={content.newTrusteeText12}
              onChange={(e) => {
                if (!editable) return;
                editTrustee("additional_information", e.target.value);
                handleChangeDescription(e);
              }}
              className={styles.large_message}
            ></textarea>
            <div className={styles.error_message}>
              {error.additional_information
                ? error.additional_information
                : null}
            </div>
            <div
              className={`${styles.file_counter} ${
                trustee.additional_information.length === maxMessageLength
                  ? styles.error_text
                  : ""
              }`}
            >
              {trustee.additional_information.length === maxMessageLength ? (
                <>{content.newTrusteeText13}</>
              ) : (
                ""
              )}
              {trustee.additional_information.length}/{maxMessageLength}{" "}
              {dublicatedcontent.dublicatedText93}
            </div>
          </div>
          <div {...editableIf(personSections.assets)}>
            {review("assets", content?.newTrusteeText14)}
            <div className={styles.delay_period}>
              <div className={styles.bold_title}>
                {content.newTrusteeText14}
              </div>
              <Info message={content.newTrusteeText15} />
              <div
                disabled={userData.isFreezed}
                onClick={() =>
                  setTrustee({
                    ...trustee,
                    assets: userData.UserData.assets.map((e) => {
                      return e.asset_id;
                    }),
                  })
                }
                className={`${styles.blue_link} enable-disable-opacity`}
              >
                {content.newTrusteeText16}
              </div>

              <div className={styles.assets_counter}>
                <span className={styles.assets_selected}>
                  {trustee?.assets.length}
                </span>
                /{userData.UserData.assets.length} {content.newTrusteeText17}
              </div>
            </div>
            <div disabled={userData.isFreezed} className={styles.assets_div}>
              <div
                className={`${styles.assets_container} enable-disable-opacity`}
              >
                {width > 590 && canSeeAssets && (
                  <AddNewAsset
                    list={true}
                    alreadySelected={trustee.assets}
                    assets={userData.UserData.assets}
                    onClick={(asset) =>
                      editTrustee("assets", [
                        ...new Set([...trustee.assets, asset.asset_id]),
                      ])
                    }
                  />
                )}
                {trustee.assets.map((asset_) => {
                  let asset_types;
                  userData.UserData.assets.map((asset) => {
                    if (asset.asset_id === asset_)
                      asset_types = (
                        <AssetType
                          key={asset.asset_id}
                          asset_type={asset.asset_type}
                          asset_name={asset.asset_name}
                          onDelete={() =>
                            setTrustee({
                              ...trustee,
                              deleted_assets: [
                                ...new Set([
                                  ...trustee.deleted_assets,
                                  asset.asset_id,
                                ]),
                              ],
                              assets: trustee.assets.filter(
                                (e) => e !== asset.asset_id
                              ),
                            })
                          }
                        />
                      );
                    return null;
                  });
                  return asset_types;
                })}
                {width <= 590 && canSeeAssets && (
                  <AddNewAsset
                    list={true}
                    alreadySelected={trustee.assets}
                    assets={userData.UserData.assets}
                    onClick={(asset) =>
                      editTrustee("assets", [
                        ...new Set([...trustee.assets, asset.asset_id]),
                      ])
                    }
                  />
                )}
              </div>
            </div>
            {review(
              "beneficiaries",
              content?.newTrusteeText18,
              <div className={styles.delay_period}>
                <div className={styles.bold_title}>
                  {content.newTrusteeText18}
                </div>
                <Info position={"top"} message={content.newTrusteeText19} />
              </div>
            )}
            <div
              disabled={userData.isFrezed}
              className={`${styles.file_container} enable-disable-opacity ${reviewMark(
                "beneficiaries",
                "block"
              )}`}
              {...editableIf(personSections.beneficiaries)}
            >
              {trustee.beneficiaries.map((user_id) => {
                let beneficiary_logo;
                userData.UserData.beneficiaries.map((beneficiary) => {
                  if (beneficiary.user_id === user_id) {
                    const avatar = userData?.UserData?.beneficiaries?.filter(
                      (y) => y.user_id === beneficiary.user_id
                    )[0]?.profile_avatar;
                    beneficiary_logo = (
                      <Beneficiarytrustee
                        avatar={avatar}
                        name={beneficiary.name}
                        priority={beneficiary.priority}
                        deleatable={true}
                        onDelete={() => {
                          setTrustee({
                            ...trustee,
                            beneficiaries: trustee.beneficiaries.filter(
                              (e) => e !== beneficiary.user_id
                            ),
                            deleted_beneficiaries: [
                              ...new Set([
                                ...trustee.deleted_beneficiaries,
                                beneficiary.user_id,
                              ]),
                            ],
                          });
                        }}
                      />
                    );
                  }
                  return null;
                });
                return beneficiary_logo;
              })}
              {/* <AddBeneficiary user_type={"beneficiaries"} onSelect={(e)=>editTrustee("beneficiaries", [...trustee.beneficiaries, e.user_id])} /> */}
              {trustee?.beneficiaries.length <= 11 && canSeeBeneficiaries && (
                <AddBeneficiary
                  specialStyle={true}
                  setShow={() => null}
                  alreadySelected={trustee.beneficiaries}
                  user_type={"beneficiaries"}
                  onSelect={(e) =>
                    editTrustee("beneficiaries", [
                      ...new Set([...trustee.beneficiaries, e.user_id]),
                    ])
                  }
                />
              )}
            </div>
          </div>

          {showPartnerFiles && (
            <PartnerFileShare partnerName={toEdit?.name} />
          )}
          {partner && showPartnerSharing && (
            <PartnerSharingPerson
              subject="trustee"
              value={personSharingValue(trustee)}
              onChange={(next) =>
                setTrustee((current) => ({ ...current, ...next }))
              }
              disabled={userData.isFreezed || !editable}
              partnerName={partner.name}
            />
          )}
          {/*
            The partner's own copy of it -- what they were given on this
            advisor, read-only. See the note in Edit Beneficiary: `getPartner`
            is null for them, the flags are already on their payload, and the
            master is forced on because they are looking at the record.
          */}
          {userData.partnerReadOnly && (
            <PartnerSharingPerson
              subject="trustee"
              viewer="partner"
              value={{
                ...personSharingValue(toEdit),
                share_with_partner: true,
              }}
              onChange={() => {}}
              disabled
            />
          )}
          <div
            className={`${styles.shadow_bottom} ${styles.shadow_bottom_edit} ${
              showBottomShadow ? styles.active : ""
            }`}
          />
        </div>
        </ViewOnly>

        <div className={styles.actions_toolbar}>
          {!readOnly && (
            <button
              disabled={!editable}
              onClick={() => {
                if (!editable) return;
                setShowConfirmation(true);
                return;
              }}
              className={styles.delete_button}
            >
              {content.newTrusteeText22}
            </button>
          )}
          <div onClick={() => onClose()} className={styles.cancel_button}>
            {content.newTrusteeText20}
          </div>
          {(!readOnly || canPropose) && (
          <button
            disabled={userData.isFreezed}
            onClick={(e) => runSave(e)}
            className={styles.save_button}
          >
            {canPropose
              ? approvalContent?.partnerApprovalText23 || "Propose changes"
              : awaitingApproval
              ? approvalContent?.partnerApprovalText14 || content.newTrusteeText21
              : content.newTrusteeText21}
          </button>
          )}
        </div>

      </div>

      {/*
        Out of the card -- see the note in EditAsset.jsx. This one's .main_box
        is overflow:scroll rather than hidden, but it is the same question, and
        the answer is the same: nothing above it here has overflow.
      */}
      {showConfirmation ? (
        <div style={{ position: "relative", zIndex: "40" }}>
          <Confirmation
            OnConfirm={() => {
              deleteTrustee();
              window.scrollTo(0, 0);
            }}
            title={dublicatedcontent?.dublicatedText211}
            text={`${dublicatedcontent?.are_you_sure_you_want_to_delete} ${trustee.name} ?`}
            onClose={() => setShowConfirmation(false)}
            cancel_button={dublicatedcontent?.dublicatedText184}
            confirm_button={dublicatedcontent?.delete}
          />
        </div>
      ) : null}
    </div>
  );
}

export default EditTrustee;
